'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgPercent(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M10.813 2.416a.682.682 0 00-.917.3l-5.07 9.973a.682.682 0 101.215.618l5.07-9.974a.682.682 0 00-.298-.917zM7.172 5.7a2.589 2.589 0 00-2.586-2.585A2.589 2.589 0 002 5.7a2.589 2.589 0 002.586 2.586A2.589 2.589 0 007.172 5.7zM4.586 6.924a1.224 1.224 0 01-1.222-1.222c0-.674.548-1.222 1.222-1.222.674 0 1.222.548 1.222 1.222 0 .674-.548 1.222-1.222 1.222zM11.382 7.735a2.589 2.589 0 00-2.586 2.586 2.589 2.589 0 002.586 2.586 2.589 2.589 0 002.585-2.586 2.589 2.589 0 00-2.585-2.586zm0 3.808a1.224 1.224 0 01-1.223-1.222 1.224 1.224 0 012.444 0c0 .674-.547 1.223-1.221 1.223z", fill: "currentColor" }))));
}

module.exports = SvgPercent;
//# sourceMappingURL=Percent.js.map
